export default "__VITE_ASSET__C58KvA6W__"